import React from 'react'
import { BsGithub } from 'react-icons/bs'
import { FaLinkedinIn } from 'react-icons/fa'

const SocialMedia = () => {
  return (
    <div className="app__social">
        <div>
          <a target="_blank" rel="noreferrer noopener" href='https://github.com/steveanil'>
            <BsGithub />
          </a>         
        </div>
        <div>
          <a target="_blank" rel="noreferrer noopener" href='https://www.linkedin.com/in/steve-aj/'>
            <FaLinkedinIn />
          </a>
        </div>
    </div>
  )
}

export default SocialMedia